import "core-js/modules/es6.function.name";
import "core-js/modules/es6.function.name";
import React from 'react';
import { BtnBox, Btn } from './styles';
export default function Submit(_ref) {
  var name = _ref.name,
      disabled = _ref.disabled,
      align = _ref.align;
  var className = 'btn-box';

  if (align) {
    className += ' btn-box--' + align;
  }

  return /*#__PURE__*/React.createElement(BtnBox, {
    className: className
  }, /*#__PURE__*/React.createElement(Btn, {
    className: "btn",
    name: "contact_form",
    disabled: disabled
  }, name));
}